import React, { useState, useEffect } from "react";

const SvgChevronLeft = ({ viewBoxInc }) => {
  const [viewBoxDim, setViewBoxDim] = useState("0 0 0 0");

  useEffect(() => {
    const height = viewBoxInc.h;
    const width = viewBoxInc.w;

    setViewBoxDim(`0 0 ${width} ${height}`);
  }, [viewBoxInc]);

  return (
    viewBoxInc?.h && (
      <svg viewBox={viewBoxDim}>
        <path
          filter="url(#shadowSVG)"
          fill="url(#Gradient1)"
          id="chevron-right-1"
          height="100%"
          width="100%"
          strokeLinecap="butt"
          strokeLinejoin="bevel"
          stroke="url(#Gradient1)"
          strokeWidth={3}
          d="M 30 0, l 0 5, l -20 15, l 20 15, l 0 5, l -27 -20 z "
        ></path>
      </svg>
    )
  );
};

export default SvgChevronLeft;
